var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAntDesignLinkedinFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ant-design:linkedin-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M64.4531 8.20312H10.5469C9.25049 8.20312 8.20312 9.25049 8.20312 10.5469V64.4531C8.20312 65.7495 9.25049 66.7969 10.5469 66.7969H64.4531C65.7495 66.7969 66.7969 65.7495 66.7969 64.4531V10.5469C66.7969 9.25049 65.7495 8.20312 64.4531 8.20312ZM25.5835 58.1323H16.8896V30.1685H25.5835V58.1323ZM21.2402 26.3452C20.2436 26.3452 19.2694 26.0497 18.4407 25.496C17.612 24.9423 16.9661 24.1553 16.5847 23.2345C16.2034 22.3137 16.1036 21.3006 16.298 20.3231C16.4924 19.3456 16.9724 18.4477 17.6771 17.743C18.3818 17.0383 19.2797 16.5583 20.2572 16.3639C21.2346 16.1695 22.2478 16.2693 23.1686 16.6507C24.0894 17.0321 24.8764 17.6779 25.4301 18.5066C25.9838 19.3353 26.2793 20.3095 26.2793 21.3062C26.272 24.0894 24.0161 26.3452 21.2402 26.3452ZM58.1323 58.1323H49.4458V44.5312C49.4458 41.2866 49.3872 37.1191 44.9268 37.1191C40.4077 37.1191 39.7119 40.6494 39.7119 44.2969V58.1323H31.0327V30.1685H39.3677V33.9917H39.4849C40.6421 31.7944 43.4766 29.4727 47.71 29.4727C56.5137 29.4727 58.1323 35.2661 58.1323 42.7954V58.1323Z",
    fill: "#0080F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntDesignLinkedinFilled);
export default __webpack_public_path__ + "static/media/ant-design-linkedin-filled.352b72b93b82289f07d8c4d0aed58b2c.svg";
export { ForwardRef as ReactComponent };